import { CART_LOAD_STATUS, CART_SAVE_STATUS } from '../../common/bulkOrder/cartUtils'

export const CART_SAVE_DEBOUNCE_MS = 500

export const canSaveCart = ({ viewerId, cart }) => {
  if (!viewerId) return false
  if (!cart) return false
  if (cart.loadStatus !== CART_LOAD_STATUS.READY) return false
  if (cart.cartOwnerId !== viewerId) return false
  return true
}

export const isCartDirty = cart => Boolean(cart?.dirty)

/**
 * @param {{ cart: object, viewerId?: string, force?: boolean }} args
 * force=true bypasses FAILED (banner / flush retry).
 */
export const shouldDispatchSave = ({ cart, viewerId, force = false } = {}) => {
  if (!canSaveCart({ viewerId, cart })) return false
  if (!isCartDirty(cart)) return false
  if (cart.saveStatus === CART_SAVE_STATUS.SAVING) return false
  // Sticky failure waits for manual flush or a new edit (which resets saveStatus to idle).
  if (!force && cart.saveStatus === CART_SAVE_STATUS.FAILED) return false
  return true
}

export const shouldFollowUpAfterSave = ({ cart, saveStatus, isCartLoading }) => {
  if (isCartLoading) return false
  if (!isCartDirty(cart)) return false
  if (saveStatus === CART_SAVE_STATUS.FAILED) return false
  return true
}
